/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './style.css';
import { useInView } from "framer-motion";
import { useRef } from "react";
function Carousel() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 700);
    };

    // Écoute du changement de taille de l'écran
    window.addEventListener('resize', handleResize);

    // Appel initial pour déterminer l'état initial
    handleResize();

    // Nettoyage du listener lors du démontage du composant
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const slides = [  {img:"electromenager",link:"électroménager & cuisine",},
{img:"beaute & sante",link:"informatique & lifestyle/lifestyle/beaute & sante",},
{img:"informatique & gaming",link:"informatique & lifestyle/informatique",},
{img: "mobilier",link:"maison & déco/meubles",},
{img:"luminaire",link:"maison & déco/luminaire",},];

  const settings = {
    focusOnSelect: true,
    pauseOnHover: false,
    infinite: true,
    speed: 1100,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: false,
  };

  return (
    <div className='carouselHome'   style={{ position:'relative'
    }}>
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index}>
            <a href={`/collections/${(slide.link)}`}>
              <img src={require(`../../images/${slide.img}.jpeg`)} alt={`Slide ${index + 1}`} />
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default Carousel;
